/* eslint-disable jsx-a11y/anchor-is-valid */
import "./ViewRequisitions.css";
import { useEffect, useState, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../../../context/AuthContext";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Form, Select, DatePicker, Input } from "antd";
import { Table, Pagination } from "antd";
import { Button } from "antd";
import { FilePdfOutlined, FileWordOutlined } from "@ant-design/icons";
import { Tag } from "antd";
import moment from "moment";
import { Typography } from "antd";
import { Radio, Space } from "antd";
import CircularPercentage from "../../../components/CircularPercentage";

export default function ViewRequisitions() {
    const { Option } = Select;
    const { Title } = Typography;
    const isMobile = window.innerWidth < 768;
    const { authData, backUrl } = useContext(AuthContext);
    const [requisitions, setRequisitions] = useState([]);
    const [departmentNames, setDepartmentNames] = useState([]);
    const [designationNames, setDesignationNames] = useState([]);
    const [organizationNames, setOrganizationNames] = useState([]);
    const [workLocation, setWorkLocation] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [next, setNext] = useState(null);
    const [prev, setPrev] = useState(null);
    const [selectedReq, setSelectedReq] = useState(null);
    const [particular, setParticular] = useState({ status: false, data: "" });
    const [showMessage, setShowMessage] = useState(false);
    const [allDepartmentNames, setAllDepartmentNames] = useState([]);
    const [allDesignationsNames, setAllDesignationsNames] = useState([]);
    const [hrTeam, setHrTeam] = useState([]);
    const [taken, setTaken] = useState(0);
    const [allocatedTo, setAllocatedTo] = useState(0);

    // ✅ Salary edit states
    const [editSalary, setEditSalary] = useState(false);
    const [salaryData, setSalaryData] = useState({
        mrf_salary_from: '',
        mrf_salary_to: ''
    });

    const firstName = authData?.employee?.first_name || "Unknown";
    const designation = authData?.employee?.designation || "N/A";

    const [message, setMessage] = useState("");

    const [filters, setFilters] = useState({
        organization: '',
        department: "",
        submission_date_after: "",
        submission_date_before: "",
        status: "Manager_Approved",
        designation: ''
    });

    const [count, setCount] = useState(null);
    const [pageSize, setPageSize] = useState(10);

    const BASE_URL = backUrl;

    const getPageFromUrl = (url) => {
        if (!url) return 1;
        try {
            const urlObj = new URL(url, window.location.origin);
            const page = urlObj.searchParams.get("page");
            return page ? parseInt(page) : 1;
        } catch {
            return 1;
        }
    };

    const fetchCount = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/api/emp/requisition-status-counts/`, {
                headers: { Authorization: `Bearer ${authData?.access}` }
            });
            setCount(res.data);
        } catch (err) {
            console.error("Failed to fetch counts:", err);
        }
    };

    const fetchRequisitions = async (url = null, page = 1) => {
        setLoading(true);
        setError("");

        let apiUrl = url;

        if (!apiUrl) {
            const params = new URLSearchParams();
            if (filters.status) params.append("status", filters.status);
            if (filters.department) params.append("department", filters.department);
            if (filters.organization) params.append("organisation", filters.organization);
            if (filters.submission_date_after && filters.submission_date_before) {
                params.append("submission_date_after", filters.submission_date_after);
                params.append("submission_date_before", filters.submission_date_before);
            }
            if (filters.designation) params.append("designation", filters.designation);
            apiUrl = `${BASE_URL}/api/emp/manpowerrequisitions/?${params.toString()}`;
        }

        try {
            const res = await axios.get(apiUrl, {
                headers: { Authorization: `Bearer ${authData?.access}` }
            });

            setRequisitions(res.data.results || []);
            setNext(res.data.next || null);
            setPrev(res.data.previous || null);
            setTotalCount(res.data.count || 0);
            setPageSize(res.data.results?.length || 10);
            setCurrentPage(page);

        } catch (err) {
            console.error("Error fetching requisitions:", err);
            setError("No Requisitions found");
            setRequisitions([]);
        } finally {
            setLoading(false);
        }
    };

    const fetchOrganizations = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/api/emp/organisations/`);
            setOrganizationNames(res.data.results);
        } catch (err) {
            console.error("Failed to fetch organizations:", err);
        }
    };

    const fetchWorkLocation = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/worklocation/`);
            setWorkLocation(res.data.results);
        } catch (err) {
            console.error("Error fetching work locations", err);
        }
    };

    const fetchDepartments = async (v) => {
        try {
            const res = await axios.get(`${BASE_URL}/api/emp/departments/?organisation=${v}`);
            setDepartmentNames(res.data.results);
        } catch (err) {
            console.error("Failed to fetch departments:", err);
        }
    };

    const fetchAllDesignations = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/api/emp/designations/`);
            setAllDesignationsNames(res.data.results);
        } catch (err) {
            console.error("Failed to fetch designations:", err);
        }
    };

    const fetchDesignations = async (v) => {
        try {
            const url = v
                ? `${BASE_URL}/api/emp/designations/?department=${v}`
                : `${BASE_URL}/api/emp/designations/`;
            const res = await axios.get(url);
            setDesignationNames(res.data.results);
        } catch (err) {
            console.error("Failed to fetch designations:", err);
        }
    };

    const fetchAllDepartments = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/api/emp/departments/`);
            setAllDepartmentNames(res.data.results);
        } catch (err) {
            console.error("Failed to fetch departments:", err);
        }
    };

    const fetchHrTeam = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/employees/?department=25`, {
                headers: { Authorization: `Bearer ${authData?.access}` }
            });
            setHrTeam(res.data.results);
        } catch (err) {
            console.error("Failed to fetch HR team:", err);
        }
    };

    const fetchTaken = async () => {
        try {
            const res = await axios.get(
                `${backUrl}/api/emp/candidates/?offerletter_status=ACCEPTED&requisition_id=${selectedReq.id}`,
                {
                    headers: {
                        Authorization: `Bearer ${authData.access}`,
                        'Content-Type': 'application/json',
                    },
                }
            );
            setTaken(res.data.count);
        } catch (err) {
            console.error("Failed to fetch taken count:", err);
        }
    };

    useEffect(() => {
        if (authData?.access) {
            fetchRequisitions();
            fetchCount();
            fetchAllDepartments();
            fetchDesignations();
            fetchOrganizations();
            fetchWorkLocation();
            fetchAllDesignations();
            fetchHrTeam();
        }
    }, [authData]);

    useEffect(() => {
        if (authData?.access) {
            fetchRequisitions(null, 1);
        }
    }, [filters]);

    useEffect(() => {
        if (selectedReq?.id) {
            fetchTaken();
        }
    }, [selectedReq]);

    const getDepartmentName = (id) => allDepartmentNames.find(d => d.id === id)?.name || "N/A";
    const getDesignationTitle = (id) => allDesignationsNames.find(d => d.id === id)?.name || "N/A";
    const getOrganizationName = (id) => organizationNames.find(o => o.id === id)?.name || "N/A";

    const getStatusClass = (status) => {
        switch (status) {
            case "Rejected": return "red-view";
            case "Sanctioned": return "green-view";
            default: return "gray-view";
        }
    };

    const desig = getDesignationTitle(designation);
    const data = `${firstName} - ${desig}`;
    const inputStyle = { width: '200px' };

    // ✅ Updated handleClickOne — pre-fills salary state
    const handleClickOne = (mrfno) => {
        setApprovalData(prev => ({ ...prev, mrf_number: mrfno }));
        const req = requisitions.find((r) => r.mrf_number === mrfno);
        setParticular({ status: true, data: mrfno });
        setSelectedReq(req);
        setEditSalary(false);
        setSalaryData({
            mrf_salary_from: req?.mrf_salary_from || '',
            mrf_salary_to: req?.mrf_salary_to || ''
        });
    };

    // ✅ Updated handleBack — resets salary state
    const handleBack = () => {
        setParticular({ status: false, data: "" });
        setSelectedReq(null);
        setEditSalary(false);
        setSalaryData({ mrf_salary_from: '', mrf_salary_to: '' });
        setApprovalData({
            mrf_number: '',
            hr_approved: '',
            hr_remarks: '',
            hr_approved_by: '',
            status: 'Submitted',
        });
    };

    const [approvalData, setApprovalData] = useState({
        mrf_number: '',
        hr_approved: '',
        hr_remarks: '',
        hr_approved_by: '',
        status: 'Submitted',
    });

    // ✅ Updated handleSubmit — includes salary in payload
    const handleSubmit = async () => {
        try {
            const payload = {
                ...approvalData,
                hr_approved_by: data,
                mrf_allocated_to: allocatedTo || null,
                mrf_salary_from: salaryData.mrf_salary_from,
                mrf_salary_to: salaryData.mrf_salary_to,
            };

            const response = await axios.put(
                `${BASE_URL}/api/emp/manpowerrequisitions/${approvalData.mrf_number}/hr_approve/`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${authData?.access}`,
                    },
                }
            );

            toast.success(response.data.message);
            fetchRequisitions();
            fetchCount();
        } catch (err) {
            console.error(err);
            toast.error(err.response?.data?.message || "Something went wrong");
        }
    };

    const handleDownload = async (type, defaultFilename) => {
        try {
            const response = await axios.get(
                `${backUrl}/api/emp/mrf/${selectedReq.mrf_number}/download/?type=${type}`,
                { responseType: 'blob' }
            );
            const disposition = response.headers['content-disposition'];
            let filename = defaultFilename;
            if (disposition && disposition.includes('filename=')) {
                filename = disposition.split('filename=')[1].replace(/['"]/g, '').trim();
            }
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Download failed', error);
            toast.error("Download failed.");
        }
    };

    const columns = [
        {
            title: "MRF Number",
            dataIndex: "mrf_number",
            key: "mrf_number",
            render: (text) => (
                <a onClick={() => handleClickOne(text)} style={{ cursor: "pointer" }}>
                    {text}
                </a>
            ),
        },
        {
            title: "Organization",
            dataIndex: "organisation",
            key: "organisation",
            render: (orgId) => getOrganizationName(orgId),
        },
        {
            title: "Department",
            dataIndex: "department",
            key: "department",
            render: (deptId) => getDepartmentName(deptId),
        },
        {
            title: "Designation",
            dataIndex: "designation",
            key: "designation",
            render: (desId) => getDesignationTitle(desId),
        },
        {
            title: "Vacancies",
            dataIndex: "no_of_vacancies",
            key: "no_of_vacancies",
        },
        {
            title: "Applied by",
            key: "submitted_by_display",
            render: (_, record) =>
                `${record.submitted_by_display || ''} ${record.submitted_by_last_name || ''}`.trim(),
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (status) => (
                <span className={getStatusClass(status)}>
                    {status === "Manager_Approved" ? "Submitted" : status}
                </span>
            ),
        },
        {
            title: "Submission Date",
            dataIndex: "submission_date",
            key: "submission_date",
        },
        {
            title: "HOD Approved Date",
            dataIndex: "manager_approval_date",
            key: "manager_approval_date",
        },
        ...(filters.status !== "Manager_Approved"
            ? [
                {
                    title: filters.status === "Sanctioned" ? "Sanctioned Date" : "Rejected Date",
                    dataIndex: "hr_approval_date",
                    key: "hr_approval_date",
                    render: (date) => date || "Pending",
                },
            ]
            : []),
    ];

    return (
        <div className="container mt-4">
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

            {!particular.status ? (
                <>
                    {isMobile ? (
                        <center>
                            <p className="mb-2" style={{ textTransform: 'uppercase', color: '#0e497b' }}>
                                View Requisitions
                            </p>
                        </center>
                    ) : (
                        <center><h5 className="mb-5">View Requisitions</h5></center>
                    )}

                    {isMobile ? (
                        <center>
                            <div>
                                {[
                                    { label: "SUBMITTED", value: "Manager_Approved", color: "blue" },
                                    { label: "SANCTIONED", value: "Sanctioned", color: "green" },
                                    { label: "REJECTED", value: "Rejected", color: "red" },
                                ].map(({ label, value, color }) => (
                                    <Tag
                                        key={value}
                                        color={filters.status === value ? color : "default"}
                                        onClick={() => setFilters({ ...filters, status: value })}
                                        style={{ cursor: "pointer", height: '20px' }}
                                    >
                                        <p>{label}</p>
                                    </Tag>
                                ))}
                            </div>
                            <br />
                        </center>
                    ) : (
                        <div className="count-area">
                            {[
                                { label: "SUBMITTED", value: "Manager_Approved", color: "blue" },
                                { label: "SANCTIONED", value: "Sanctioned", color: "green" },
                                { label: "REJECTED", value: "Rejected", color: "red" },
                            ].map(({ label, value, color }) => (
                                <Tag
                                    key={value}
                                    color={filters.status === value ? color : "default"}
                                    onClick={() => setFilters({ ...filters, status: value })}
                                    style={{ cursor: "pointer" }}
                                >
                                    <h6>{label}</h6>
                                </Tag>
                            ))}
                        </div>
                    )}

                    <div className="filters-area">
                        <Form.Item label="Organization">
                            <Select
                                placeholder="-- Select organization --"
                                value={filters.organization || undefined}
                                onChange={(value) => {
                                    setFilters({ ...filters, organization: value || '' });
                                    if (value) fetchDepartments(value);
                                }}
                                allowClear
                                style={inputStyle}
                            >
                                {organizationNames.map((item) => (
                                    <Option key={item.id} value={item.id}>{item.name}</Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item label="Department">
                            <Select
                                showSearch
                                placeholder="-- Select Department --"
                                value={filters.department || undefined}
                                onChange={(value) => {
                                    setFilters({ ...filters, department: value || '' });
                                    if (value) fetchDesignations(value);
                                }}
                                allowClear
                                style={inputStyle}
                                filterOption={(input, option) =>
                                    option?.children?.toLowerCase().includes(input.toLowerCase())
                                }
                            >
                                {departmentNames.map((item) => (
                                    <Option key={item.id} value={item.id}>{item.name}</Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item label="Designation">
                            <Select
                                showSearch
                                placeholder="-- Select Designation --"
                                value={filters.designation || undefined}
                                onChange={(value) => setFilters({ ...filters, designation: value || '' })}
                                allowClear
                                style={inputStyle}
                                filterOption={(input, option) =>
                                    option?.children?.toLowerCase().includes(input.toLowerCase())
                                }
                            >
                                {designationNames.map((item) => (
                                    <Option key={item.id} value={item.id}>{item.name}</Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item label="Submission From">
                            <DatePicker
                                style={{ width: "100%" }}
                                value={filters.submission_date_after ? moment(filters.submission_date_after, "YYYY-MM-DD") : null}
                                onChange={(_, dateString) =>
                                    setFilters({ ...filters, submission_date_after: dateString })
                                }
                                format="YYYY-MM-DD"
                                allowClear
                            />
                        </Form.Item>

                        <Form.Item label="Submission To">
                            <DatePicker
                                style={{ width: "100%" }}
                                value={filters.submission_date_before ? moment(filters.submission_date_before, "YYYY-MM-DD") : null}
                                onChange={(_, dateString) =>
                                    setFilters({ ...filters, submission_date_before: dateString })
                                }
                                format="YYYY-MM-DD"
                                allowClear
                            />
                        </Form.Item>
                    </div>

                    {loading ? (
                        <p>Loading...</p>
                    ) : error ? (
                        <p className="text-danger">{error}</p>
                    ) : (
                        <>
                            <br />
                            <Table
                                columns={columns}
                                dataSource={requisitions}
                                rowKey="id"
                                bordered
                                pagination={false}
                                locale={{ emptyText: "No requisitions found." }}
                                components={{
                                    header: {
                                        cell: (props) => (
                                            <th {...props} style={{ backgroundColor: "#0e497b", color: "#fff" }} />
                                        ),
                                    },
                                }}
                                scroll={{ x: "max-content" }}
                                style={{ width: "100%" }}
                            />

                            <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
                                <Pagination
                                    current={currentPage}
                                    total={totalCount}
                                    pageSize={pageSize}
                                    showSizeChanger={false}
                                    onChange={(page) => {
                                        if (page < currentPage && prev) fetchRequisitions(prev, page);
                                        else if (page > currentPage && next) fetchRequisitions(next, page);
                                    }}
                                />
                            </div>
                        </>
                    )}
                </>
            ) : (
                <>
                    <button className="bread" onClick={handleBack}>← List</button>

                    <div className="d-flex justify-content-center align-items-center">
                        <section>
                            <center><h5>Manpower Requisition Form</h5></center>
                        </section>
                        {selectedReq.status === "Sanctioned" && (
                            <section className="mx-5">
                                <CircularPercentage vacancies={selectedReq.no_of_vacancies} taken={taken} />
                            </section>
                        )}
                    </div>

                    <div className="form container">
                        <Form.Item label="Organization">
                            <Input value={getOrganizationName(selectedReq.organisation)} style={inputStyle} readOnly />
                        </Form.Item>
                        <Form.Item label="Department">
                            <Input value={getDepartmentName(selectedReq.department)} style={inputStyle} readOnly />
                        </Form.Item>
                        <Form.Item label="Designation">
                            <Input value={getDesignationTitle(selectedReq.designation)} style={inputStyle} readOnly />
                        </Form.Item>
                        <Form.Item label="Site/Location">
                            <Input value={selectedReq.site_location} style={inputStyle} readOnly />
                        </Form.Item>
                        <Form.Item label="Required By">
                            <Input value={selectedReq.required_by || ""} style={inputStyle} readOnly />
                        </Form.Item>
                        <Form.Item label="No. of Vacancies">
                            <Input value={selectedReq.no_of_vacancies || ""} style={inputStyle} readOnly />
                        </Form.Item>
                    </div>

                    <center>
                        <div id="center-area">
                            <div id="requisition-type">
                                <Form.Item label="Requisition Type">
                                    <Input value={selectedReq.requisition_type || ""} style={inputStyle} readOnly />
                                </Form.Item>
                            </div>

                            {selectedReq.hr_approved && (
                                <div id="download-area">
                                    <Typography.Text>Download</Typography.Text>
                                    <Button
                                        type="link"
                                        icon={<FilePdfOutlined style={{ fontSize: '30px' }} />}
                                        onClick={() => handleDownload(1, 'download.pdf')}
                                    />
                                    <Button
                                        type="link"
                                        icon={<FileWordOutlined style={{ fontSize: '30px' }} />}
                                        onClick={() => handleDownload(2, 'download.docx')}
                                    />
                                </div>
                            )}
                        </div>
                    </center>

                    <hr />

                    <div className="form-2">
                        <div className="deployment-area">
                            <h5>Deployment</h5>
                            <label>Place Of Work</label>
                            <input
                                type="text"
                                value={
                                    Array.isArray(selectedReq.place_of_work)
                                        ? selectedReq.place_of_work.join(", ")
                                        : ""
                                }
                                readOnly
                            />

                            <label>Job Description</label>
                            <textarea value={selectedReq.job_description || ""} readOnly />

                            <a
                                className="jd-anchor"
                                href={selectedReq.job_description_attachment}
                                style={{ background: 'transparent', color: 'black', textDecoration: 'none' }}
                                onMouseEnter={(e) => { e.target.style.color = 'black'; }}
                                onMouseLeave={(e) => { e.target.style.color = 'black'; }}
                            >
                                JD Attachment : View File
                            </a>

                            <hr />

                            {/* ✅ Salary Range with Edit Toggle */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                                <h5 style={{ margin: 0 }}>Salary Range</h5>
                                {selectedReq.status !== "Sanctioned" && selectedReq.status !== "Rejected" && (
                                    <Button
                                        size="small"
                                        type="link"
                                        onClick={() => setEditSalary(prev => !prev)}
                                        style={{ color: '#125ea7', padding: 0 }}
                                    >
                                        {editSalary ? 'Cancel' : 'Edit'}
                                    </Button>
                                )}
                            </div>

                            <label>From</label>
                            {editSalary ? (
                                <Input
                                    placeholder="Salary From"
                                    value={salaryData.mrf_salary_from}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        if (/^\d*$/.test(val)) {
                                            setSalaryData(prev => ({ ...prev, mrf_salary_from: val }));
                                        }
                                    }}
                                    style={{ width: '100%', marginBottom: '8px' }}
                                />
                            ) : (
                                <input
                                    type="text"
                                    value={salaryData.mrf_salary_from || ""}
                                    readOnly
                                />
                            )}

                            <label>To</label>
                            {editSalary ? (
                                <Input
                                    placeholder="Salary To"
                                    value={salaryData.mrf_salary_to}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        if (/^\d*$/.test(val)) {
                                            setSalaryData(prev => ({ ...prev, mrf_salary_to: val }));
                                        }
                                    }}
                                    style={{ width: '100%' }}
                                />
                            ) : (
                                <input
                                    type="text"
                                    value={salaryData.mrf_salary_to || ""}
                                    readOnly
                                />
                            )}
                        </div>

                        <div className="requirement-profile">
                            <h3>Requirement Profile</h3>
                            <label>Qualification</label>
                            <input type="text" value={selectedReq.qualification || ""} readOnly />
                            <label>Experience</label>
                            <input type="text" value={selectedReq.experience || ""} readOnly />
                            <label>Skill Sets</label>
                            <textarea value={selectedReq.skill_sets || ""} readOnly />
                            <label>Any Other Requirements</label>
                            <textarea value={selectedReq.other_requirements || ""} readOnly />
                            <label>Justification</label>
                            <textarea value={selectedReq.justification || ""} readOnly />
                        </div>
                    </div>

                    {selectedReq.requisition_type === 'Replacement' && (
                        <>
                            <h3>If Replacement</h3>
                            <div className="replacement-form">
                                <div className="form-group">
                                    <label>Name of the Leaving Employee</label>
                                    <input type="text" value={selectedReq.name_of_leaving_employee || ""} readOnly />
                                </div>
                                <div className="form-group">
                                    <label>Date of Leaving</label>
                                    <input type="text" value={selectedReq.date_of_leaving || ""} readOnly />
                                </div>
                                <div className="form-group">
                                    <label>Reason for Leaving</label>
                                    <textarea value={selectedReq.reason_for_leaving || ""} readOnly />
                                </div>
                                <div className="form-group">
                                    <label>Present Strength in the Category</label>
                                    <input type="text" value={selectedReq.present_dept_strength || ""} readOnly />
                                </div>
                                <div className="form-group">
                                    <label>Strength of the Function</label>
                                    <input type="text" value={selectedReq.strength_of_function || ""} readOnly />
                                </div>
                                <div className="form-group">
                                    <label>Remarks</label>
                                    <textarea value={selectedReq.replacement_remarks || ""} readOnly />
                                </div>
                            </div>
                        </>
                    )}

                    {(selectedReq.manager_approved === true || selectedReq.manager_approved === false ||
                        selectedReq.manager_approved === 1 || selectedReq.manager_approved === 0) && (
                            <center>
                                <div className="p-4" id="approval-hod" style={{ textAlign: "center" }}>
                                    <Title level={4}>HOD Approval Status</Title>
                                    <br />
                                    <div className="approval-area">
                                        <Space direction="vertical" size="middle" style={{ width: "100%" }}>
                                            <Radio.Group
                                                name="manager_approved"
                                                value={selectedReq.manager_approved}
                                            >
                                                <Radio value={1}>Approved</Radio>
                                                <Radio value={0}>Rejected</Radio>
                                            </Radio.Group>
                                            <Input.TextArea
                                                rows={4}
                                                placeholder="Remarks"
                                                value={selectedReq.manager_remarks || ""}
                                                readOnly
                                                style={{ maxWidth: '500px' }}
                                            />
                                        </Space>
                                    </div>
                                </div>
                            </center>
                        )}

                    {(selectedReq.status === "Sanctioned" || selectedReq.status === "Rejected") ? (
                        <center>
                            <div className="p-4" id="approval-hr" style={{ textAlign: "center" }}>
                                <Title level={4}>APPROVAL</Title>
                                <br />
                                <div className="approval-area">
                                    <Space direction="vertical" size="middle" style={{ width: "100%" }}>
                                        <Radio.Group name="hr_approved" value={selectedReq.hr_approved}>
                                            <Radio value={1}>Sanctioned</Radio>
                                            <Radio value={0}>Rejected</Radio>
                                        </Radio.Group>
                                        <Input.TextArea
                                            rows={4}
                                            placeholder="Enter remarks"
                                            value={selectedReq.hr_remarks}
                                            style={{ maxWidth: '500px' }}
                                            readOnly
                                        />
                                    </Space>
                                </div>
                                <br />
                                {(selectedReq.mrf_allocated_to !== '0' || selectedReq.mrf_allocated_to !== 0) && (
                                    <Select
                                        placeholder="Select HR"
                                        style={{ width: 200 }}
                                        allowClear={false}
                                        value={selectedReq.mrf_allocated_to}
                                        disabled
                                    >
                                        <Select.Option value={selectedReq.mrf_allocated_to}>
                                            {selectedReq.mrf_allocated_to_display}
                                        </Select.Option>
                                    </Select>
                                )}
                            </div>
                        </center>
                    ) : (
                        <center>
                            <div className="p-4" id="approval-hr" style={{ textAlign: "center" }}>
                                <Title level={4}>APPROVAL</Title>
                                <br />
                                <div className="approval-area">
                                    <Space direction="vertical" size="middle" style={{ width: "100%" }}>
                                        <Radio.Group
                                            name="hr_approved"
                                            value={approvalData.hr_approved}
                                            onChange={(e) =>
                                                setApprovalData(prev => ({ ...prev, hr_approved: e.target.value }))
                                            }
                                        >
                                            <Radio value={true}>Sanction</Radio>
                                            <Radio value={false}>Reject</Radio>
                                        </Radio.Group>
                                        <Input.TextArea
                                            rows={4}
                                            placeholder="Remarks"
                                            value={approvalData.hr_remarks}
                                            onChange={(e) =>
                                                setApprovalData(prev => ({ ...prev, hr_remarks: e.target.value }))
                                            }
                                            style={{ maxWidth: "500px", margin: "0 auto" }}
                                        />
                                    </Space>
                                </div>
                                <br />

                                {authData?.employee?.is_superuser && (
                                    <center>
                                        <Select
                                            placeholder="Select HR"
                                            style={{ width: 200 }}
                                            allowClear
                                            onChange={(value) => setAllocatedTo(value)}
                                        >
                                            {hrTeam.map((item) => (
                                                <Option key={item.id} value={item.id}>
                                                    {item?.first_name}
                                                </Option>
                                            ))}
                                        </Select>
                                    </center>
                                )}

                                <br />
                                <center>
                                    <Button
                                        style={{ backgroundColor: "#0e497b", color: "white" }}
                                        onClick={handleSubmit}
                                    >
                                        Submit
                                    </Button>
                                </center>
                            </div>
                        </center>
                    )}

                    <br />
                    {showMessage && (
                        <p className={message === "Requisition has been rejected." ? "reject-message" : "success-message"}>
                            {message}
                        </p>
                    )}
                </>
            )}
        </div>
    );
}